import { APP_CONFIG } from '../../config';
import { get } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import type { CreditHistoryResponse } from '../../@types/creditHistory';
import type { CreditHistoryPriority } from '@/components/content/creditHistoryPage/creditHistory.util';

export const getCreditHistory = async (
  priority: CreditHistoryPriority = 'PRIORITY_CONTACT_RENT',
): Promise<CreditHistoryResponse> => {
  return await get<CreditHistoryResponse>(
    `${APP_CONFIG.entitlementApiUrl}${ApiEndpoints.creditHistory}?benefitType=${priority}`,
  );
};
